export default __webpack_public_path__ + "static/media/hoja-helecho.635bcb06.png";